<template>
  <div class="page">
   <div class="bg-white " style="height: calc(100%);">
    <el-card>
      <el-form size="small"  class="" ref="searchForm" :model="detForm">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="" label="项目编号：">
              <span>{{ detForm.project.proCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label="项目名称：">
              <span>{{ detForm.project.name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="" label="项目单价：">
              <span>$ {{ $mathUtil.mathToFixed(detForm.price) }} / {{ detForm.unitEn }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="text" class="ml4" size="small" @click="saveOrUpdateProject(detForm)">配置项目信息</el-button>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="" label="项目备注信息：">
              <span>{{ detForm.description }}</span> 
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="封面" prop="cover"
              :rules="[
              {required: true, message:'封面不能为空', trigger:'blur'}
              ]">
                <CropperView ref="cropperviewRef" 
                :imgSrc="detForm.cover" 
                :autoCropWidth="88"
                :autoCropHeight="88" 
                :disabled="false"  
                :actionButtonFlag="true" 
                :objectFit="'cover'" 
                :listIndex="1" 
                @updateChange="changeImage($event,detForm)">
                </CropperView>
            </el-form-item>
          </el-col> -->
        <el-col :span="24">
          <el-form-item label="项目图片：" prop="">
            <div class="flex-row flex-w">
              <el-image v-for="item in detForm.picJsonList" :key="item.id" :src="item.fileUrl" style="width: 100px;height:100px;margin:0 10px 10px 0" :preview-src-list="srcList"></el-image>
            </div>
           </el-form-item>
        </el-col>
        </el-row>
      </el-form>
    </el-card>
      <div class="tableTitle">已选材料：</div>
      <div style="min-height: calc(50% - 20px);">
      <vxe-table
          border="full"
          auto-resize
          resizable
          height="auto"
          :loading="loading"
          size="small"
          ref="cecUnmSetsTable"
          show-header-overflow
          show-overflow
          highlight-hover-row
          :menu-config="{}"
          :print-config="{}"
          :import-config="{
          importMethod: importMethod,
              types: ['csv', 'xls', 'xlsx'],
              remote: true,
          }"
          :export-config="{
              remote: true,
              filename: `套餐表数据${moment(new Date()).format(
              'YYYY-MM-DD'
              )}`,
              sheetName: '套餐表数据',
              exportMethod: exportMethod,
              types: ['xlsx'],
              modes: ['current', 'selected', 'all'],
          }"
          @sort-change="sortChangeHandle"
          :expand-config="{accordion: true, lazy: true, loadMethod: loadContentMethod}"
          :sort-config="{remote:true}"
          :data="dataList"
          :checkbox-config="{}">
          <!-- <vxe-column type="seq" width="40"></vxe-column> -->
          <!-- <vxe-column type="checkbox"  width="40px"></vxe-column> -->
          <!-- <vxe-column
      field="sort"
      width="50px"
      title="排序">
    </vxe-column> -->
    <vxe-column
      field="isMain"
      width="100"
      align="center"
      title="材料使用">
        <template slot-scope="scope">
          <span>{{ scope.row.mateKind }}</span>   
        </template>
    </vxe-column>
    <vxe-column type="expand" width="80" align="center"  title="可选材料">
      <template #default="{row}">
        <span v-if="row.itemSize > 0">{{ row.itemSize }}</span>
      </template>
      <template #content="{ row }">
        <div style="padding: 10px;">
          <vxe-table
            border="full"
            auto-resize
            resizable
            :loading="loadingch"
            size="small"
            ref="cecItemTable2"
            show-header-overflow
            show-overflow
            highlight-hover-row 
            :data="row.childData">
            <vxe-column type="seq"  align="center" width="50"  title="序号"></vxe-column>
            <vxe-column
              field="code"
              align="center"
              width="100"
              title="物品编码">
                <template slot-scope="scope">
                    <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmsets:cecUnmSets:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
                    <el-link  type="primary" :underline="false" v-if="hasPermission('cecitem:cecItem:view')"  @click="view(scope.row)">{{scope.row.code ? scope.row.code : ''}}</el-link>
                    <span v-else>{{scope.row.code ? scope.row.code :''}}</span>
                  </template>
            </vxe-column>
            <vxe-column
              field="nameCn"
              align="center"
              show-overflow
              title="中文名称">
              <template slot-scope="scope">
                  <el-tooltip v-if="scope.row.nameCn" class="item" effect="dark" :content="scope.row.nameCn ? scope.row.nameCn : ''" placement="top">
                    <div class="textOverflow">{{ scope.row.nameCn ? scope.row.nameCn : '' }}</div>
                  </el-tooltip>
                  <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.name : ''" placement="top">
                    <div class="textOverflow">{{ scope.row.category ? scope.row.category.name : '' }}</div>
                  </el-tooltip>
                </template>
            </vxe-column>
            <vxe-column
              field="name"
              align="center"
              title="英文名称">
              <template slot-scope="scope">
                  <el-tooltip v-if="scope.row.itemId" class="item" effect="dark" :content="scope.row.name ? scope.row.name :''" placement="top">
                    <div class="textOverflow">{{ scope.row.name ? scope.row.name : '' }}</div>
                  </el-tooltip>
                  <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.nameEn : ''" placement="top">
                    <div class="textOverflow">{{ scope.row.category ? scope.row.category.nameEn : '' }}</div>
                  </el-tooltip>
                </template>
            </vxe-column>
            <vxe-column
              field="category.name"
              align="center"
              width="100"
              sortable
              title="材料类别">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.category ? scope.row.category.parentIdsName : ''" placement="top">
                  <div class="textOverflow">{{ scope.row.category ? scope.row.category.name : '' }}</div>
                </el-tooltip>
              </template>
            </vxe-column>
            <vxe-column
              field="price"
              align="center"
              width="100"
              sortable
              title="单价">
              <template slot-scope="scope">
                <div class="flexBetween">
                  <span>$</span>
                  <div v-if="scope.row.price">
                    <span>{{ scope.row.price }} / </span>   
                    <span>{{ scope.row.units ? scope.row.units.unitEn : '' }}</span>
                  </div>
                </div>
                </template>
            </vxe-column>
            <vxe-column
              field="picture"
              width="200"
              align="center"
              title="图片">
                <template slot-scope="scope">
                    <PopoverTipList
                      v-if="scope.row.picJsonList"
                      labelValue = 'id'
                      tableType = "length"
                      tableHeight = '500px'
                      boxWidth="200"
                      :imageDisabled="true"
                      :columns="[
                      ]"
                      :selectArray="scope.row.picJsonList"
                    ></PopoverTipList>
                    <span v-else>-</span>
                  </template>
            </vxe-column>
            <vxe-column
              fixed="right"
              align="center"
              width="250"
              title="操作">
              <template  slot-scope="scope">
                <div class="flex-row ai-center jc-center">
                  <el-button type="text" class="ml4" size="small" @click="saveOrUpdateMaterialInfo(scope.row)">配置材料信息</el-button>
                </div>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
      </template>
    </vxe-column>
    <vxe-column
      field="code"
      align="center"
      width="100"
      title="物品编码">
        <template slot-scope="scope">
            <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmsets:cecUnmSets:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
            <el-link  type="primary" :underline="false" v-if="hasPermission('cecitem:cecItem:view')"  @click="view(scope.row)">{{scope.row.item ? scope.row.item.code : ''}}</el-link>
            <span v-else>{{scope.row.item ? scope.row.item.code :''}}</span>
          </template>
    </vxe-column>
  <vxe-column
      field="nameCn"
      align="center"
      show-overflow
      title="中文名称">
      <template slot-scope="scope">
          <el-tooltip v-if="scope.row.itemId" class="item" effect="dark" :content="scope.row.item ? scope.row.item.nameCn : ''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.nameCn : '' }}</div>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.name : ''" placement="top">
            <div class="textOverflow">{{ scope.row.category ? scope.row.category.name : '' }}</div>
          </el-tooltip>
        </template>
    </vxe-column>
  <vxe-column
      field="name"
      align="center"
      title="英文名称">
      <template slot-scope="scope">
          <el-tooltip v-if="scope.row.itemId" class="item" effect="dark" :content="scope.row.item ? scope.row.item.name :''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.name : '' }}</div>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.nameEn : ''" placement="top">
            <div class="textOverflow">{{ scope.row.category ? scope.row.category.nameEn : '' }}</div>
          </el-tooltip>
        </template>
    </vxe-column>
    <vxe-column
        field="name"
        align="center"
        width="100"
        title="材料类别">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.item ? scope.row.item.category.parentIdsName : ''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.category.name : '' }}</div>
          </el-tooltip>
        </template>
      </vxe-column>
      <vxe-column
      field="num"
      align="center"
      width="100"
      title="单价">
      <template slot-scope="scope">
        <div class="flexBetween">
          <span>$</span>
          <div v-if="scope.row.item">
            <span>{{ scope.row.price }} / </span>   
            <span>{{ scope.row.item.units ? scope.row.item.units.unitEn : '' }}</span>
          </div>
        </div>
        </template>
    </vxe-column>
      
  <!-- <vxe-column
      field="minUsage"
      align="center"
      title="面积/数量">
    </vxe-column> -->
    <vxe-column
      field="rateNum"
      width="100"
      align="center"
      title="损耗率">
        <template slot-scope="scope">
          <span>{{ scope.row.rateNum }}%</span>
        </template>
    </vxe-column>
  <vxe-column
      field="rateDesc"
      align="center"
      title="损耗率描述">
    </vxe-column>
    <vxe-column
          field="picture"
          width="200"
          align="center"
          title="图片">
            <template slot-scope="scope">
                <PopoverTipList
                  v-if="scope.row.picJsonList.length > 0 "
                  labelValue = 'id'
                  tableType = "length"
                  tableHeight = '500px'
                  boxWidth="200"
                  :imageDisabled="true"
                  :columns="[
                  ]"
                  :selectArray="scope.row.picJsonList"
                ></PopoverTipList>
                <span v-else>-</span>
              </template>
        </vxe-column>
    <!-- <vxe-column
      field="rateNum"
      width="100"
      align="center"
      title="可选材料">
        <template slot-scope="scope">
          <div v-if="!scope.row.isItemSelectIds">
                  -
                </div>
                <PopoverTipList
                  v-else
                  labelValue = 'id'
                  tableType = "length"
                  :value = "scope.row.isItemSelectIds"
                  :sortDisabled="true"
                  :imageDisabled="true"
                  :columns="[
                    {
                      prop: 'code',
                      label: '物品编码'
                    },
                    {
                      prop: 'nameCn',
                      label: '中文名称'
                    },
                    {
                      prop: 'name',
                      label: '英文名称'
                    },
                    {
                      prop: 'category.name',
                      label: '材料类别'
                    }
                  ]"
                  :selectArray="scope.row.itemList"
                ></PopoverTipList>
        </template>
    </vxe-column> -->
    <vxe-column
        fixed="right"
        align="center"
        width="250"
        title="操作">
        <template  slot-scope="scope">
          <div class="flex-row ai-center jc-center">
          <div v-if="scope.row.itemId">
            <GridSelect
                ref="gridselectRef"
                title="配置可选材料"
                labelName = 'nameCn'
                :disabled="false"
                :showPagination="false"
                showType="none"
                labelValue = 'id'
                :value = "scope.row.isItemSelectIds"
                :limit="50"
                @getValue='updateItemSelectIds($event,scope.row)'
                :columns="[
                {
                  prop: 'code',
                  width: '80',
                  label: '材料编号'
                },
                {
                  prop: 'nameCn',
                  width: '100',
                  label: '材料名称'
                },
                {
                  prop: 'image',
                  width: '50',
                  label: '图片'
                }
                ]"
                :searchs="[
                {
                  prop: 'code',
                  label: '材料编号'
                },
                {
                  prop: 'nameCn',
                  label: '材料名称'
                }
                ]"
                dataListUrl="/cecitem/cecItem/parentList"
                queryEntityUrl="/cecitem/cecItem/queryById"
                :params="{
                  orders: [{ column: 'a.code', asc: true }],
                  parentId:scope.row.item.parentId == '0' ? scope.row.item.id : scope.row.item.parentId 
                }"
                >
              </GridSelect>
          </div>
            <el-button type="text" class="ml4" size="small" @click="saveOrUpdateMaterialInfo(scope.row)">配置材料信息</el-button>
          </div>
        </template>
      </vxe-column>
  </vxe-table>
  </div>
  </div>
      <!-- 弹窗, 新增 / 修改 -->
  <CecItemForm  ref="cecItemForm" @refreshDataList="refreshList"></CecItemForm>
  <CecUnmMaterialInfoByItemForm  ref="CecUnmMaterialInfoByItemFormRef" @refreshDataList="refreshList"></CecUnmMaterialInfoByItemForm>
  <CecUnmProjectByItemForm  ref="CecUnmProjectByItemFormRef" @refreshDataList="getProjectDetail"></CecUnmProjectByItemForm>
</div>
</template>

<script>
import CecItemForm from '../cecitem/CecItemForm.vue'
import CecUnmMaterialInfoByItemForm from '../cecunmmaterialinfo/CecUnmMaterialInfoByItemForm.vue'
import CecUnmProjectByItemForm from '../cecunmmaterialinfo/CecUnmProjectByItemForm.vue'
import cecUnmSetsService from '@/api/unmsets/cecUnmSetsService'
import csmpProjectService from '@/api/cecunmsetmealpositionproject/cecUnmSetMealPositionProjectService'
import ItemService from '@/api/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItemService'
import GridSelect from '@/components/gridSelect/setItem.vue'
import PopoverTipList from '@/components/popoverTip/indexList.vue'
import CropperView from '@/components/upload/ImageUploadCropper.vue'
export default {
  data () {
    return {
      detForm: {
        unitEn: '',
        price: 0,
        description: '',
        unitCn: '',
        project: {
          proCode: '',
          name: ''
        },
        picJsonList: []
      },
      srcList: [],
      dataList: [],
      tablePage: {
        orders: [{ column: 'sort', asc: false }]
      },
      loading: false,
      projectId: '',
      urlHearder: '',
      loadingch: false
    }
  },
  components: {
    CecItemForm,
    GridSelect,
    PopoverTipList,
    CropperView,
    CecUnmMaterialInfoByItemForm,
    CecUnmProjectByItemForm
  },
  activated () {
    this.urlHearder = localStorage.getItem('imageDomainName')
    this.projectId = this.$route.query.id
    this.refreshList()
  },
  methods: {
    saveOrUpdateMaterialInfo (data) {
      if (data.materialInfo) {
        this.$refs.CecUnmMaterialInfoByItemFormRef.init('edit', data.materialInfo.id)
      } else {
        this.$refs.CecUnmMaterialInfoByItemFormRef.init('add', '', data.itemId ? data.itemId : data.id)
      }
    },
    saveOrUpdateProject (data) {
      this.$refs.CecUnmProjectByItemFormRef.init('edit', data.id)
    },
    // 子表单
    loadContentMethod ({ row }) {
      this.loadingch = true
      // this.parentCode = row.code
      return new Promise(resolve => {
        setTimeout(() => {
          if (!row.isItemSelectIds) {
            row.childData = []
            this.loadingch = false
          } else {
            ItemService.allItemList({
              ids: row.isItemSelectIds
            }).then((res) => {
              row.childData = res.data.map(citem => {
                citem.picJsonList = this.stitchingImages(citem)
                return citem
              })
              this.loadingch = false
            }).catch(() => {
              this.loadingch = false
            })
          }
          resolve()
        }, 500)
      })
    },
    //  upload image 上传图片
    changeImage (e, item) {
      if (e) {
        item.cover = typeof e === 'string' ? e : e.filePath
        item.coverImage = {
          actorId: e.actorId,
          actorName: e.actorName,
          fileName: e.fileName,
          category: 'setsProjectCover',
          filePath: typeof e === 'string' ? e : e.filePath
        }
        this.updataProjectCover(item)
      } else {
        item.cover = ''
      }
    },
    updataProjectCover (item) {
      let query = {
        id: item.id,
        coverImage: item.coverImage
      }
      csmpProjectService.save(query).then(({data}) => {
        this.$message.success('设置成功')
        this.refreshList()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    updateItemSelectIds (e, row) {
      row.isItemSelectIds = e
      this.loading = true
      ItemService.save(row).then(({data}) => {
        this.$message.success('设置成功')
        this.loading = false
        this.refreshList()
      }).catch(() => {
        this.loading = false
      })
    },
    // 跳转套餐项目列表
    handSetsProject () {

    },
    // 获取cec套餐表数据
    getCecProject () {
      this.loading = true
      cecUnmSetsService.getCecProject({}).then(({res}) => {
        this.refreshList()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取项目详情
    getProjectDetail () {
      this.srcList = []
      // this.$refs.cropperviewRef.resetFields()
      this.detForm.cover = ''
      this.loading = true
      csmpProjectService.queryById(this.projectId).then(({data}) => {
        // this.inputForm = this.recover(this.inputForm, data)
        this.detForm = data
        this.detForm.unitCn = data.project.unit ? data.project.unit.unit : ''
        this.detForm.unitEn = data.project.unit ? data.project.unit.unitEn : ''
        this.loading = false
        if (data.coverImage) {
          this.detForm.cover = data.coverImage.filePath
        }
        if (data.picJson) {
          this.detForm.picJsonList = JSON.parse(data.picJson).map(citem => {
            let concatenatingUrls = this.urlHearder + citem.fileStorePath + citem.filesIn
            citem.fileUrl = concatenatingUrls
            this.srcList.push(concatenatingUrls)
            return citem
          })
        }
      })
    },
    // 获取数据列表
    refreshList () {
      this.getProjectDetail()
      ItemService.list({
        positionProjectId: this.projectId,
        orders: [{ column: 'mate_kind', asc: true }],
        current: 1,
        size: 100
      }).then(({data}) => {
        this.dataList = data.records.map(item => {
          item.picJsonList = this.stitchingImages(item.item)
          // item.itemList = item.itemList.map(citem => {
          //   citem.picJsonList = this.stitchingImages(citem)
          //   return citem
          // })
          return item
        })
      })
    },
    // 处理材料图片（材料图片需要拼接链接）
    stitchingImages (data) {
      let picJsonList = []
      if (!data) {
        return picJsonList
      }
      if (data.parentId === '0') {
        if (data.picJson) {
          picJsonList = JSON.parse(data.picJson).map(citem => {
            citem.fileUrl = this.urlHearder + citem.fileStorePath + '/' + citem.filesIn
            return citem
          })
        } else if (data.mainItem) {
          let splitData = data.mainItem.picture.split('|')
          picJsonList = splitData.map(citem => {
            let itemUP = {
              fileStorePath: 'item/' + data.mainItem.code + '/' + citem,
              filesIn: citem,
              remarks: '',
              fileUrl: this.urlHearder + 'item/' + data.mainItem.code + '/' + citem
            }
            return itemUP
          })
        }
      } else {
        if (data.picture) {
          let splitData = data.picture.split('|')
          picJsonList = splitData.map(citem => {
            let itemUP = {
              fileStorePath: 'item/' + data.code + '/' + citem,
              filesIn: citem,
              remarks: '',
              fileUrl: this.urlHearder + 'item/' + data.code + '/' + citem
            }
            return itemUP
          })
        } else {
          picJsonList = []
        }
      }
      return picJsonList
    },
    // 当前页
    currentChangeHandle ({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.refreshList()
    },
    // 排序
    sortChangeHandle (obj) {
      this.tablePage.orders = []
      if (obj.order != null) {
        this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
      } else {
        this.tablePage.orders = [{ column: 'create_date', asc: false }]
      }
      this.refreshList()
    },
    // 新增
    add () {
      this.$refs.cecUnmSetsForm.init('add', '')
    },
    // 修改
    edit (id) {
      id = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
        return item.id
      })[0]
      this.$refs.cecUnmSetsForm.init('edit', id)
    },
    // 查看
    view (data) {
      let query = {
        id: data.itemId,
        parentCode: ''
      }
      this.$refs.cecItemForm.init('view', query)
    },
    // 删除
    del (id) {
      let ids = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
        return item.id
      }).join(',')
      this.$confirm(`确定删除所选项吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        cecUnmSetsService.delete(ids).then(({data}) => {
          this.$message.success(data)
          this.refreshList()
          this.loading = false
        })
      })
    },
    // 下载模板
    downloadTpl () {
      this.loading = true
      cecUnmSetsService.exportTemplate().then(({data}) => {
  // 将二进制流文件写入excel表，以下为重要步骤
        this.$utils.downloadExcel(data, '请假表单导入模板')
        this.loading = false
      }).catch(function (err) {
        this.loading = false
        if (err.response) {
          console.log(err.response)
        }
      })
    },
    // 自定义服务端导入
    importMethod ({ file }) {
    // 处理表单
      const formBody = new FormData()
      formBody.append('file', file)
      this.loading = true
      cecUnmSetsService.importExcel(formBody).then(({data}) => {
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: data
        })
        this.refreshList()
      })
    },
    // 自定义服务端导出
    exportMethod ({ options }) {
    // 传给服务端的参数
      const params = {
        current: this.tablePage.currentPage,
        size: this.tablePage.pageSize,
        orders: this.tablePage.orders,
        ...this.searchForm,
        filename: options.filename,
        sheetName: options.sheetName,
        isHeader: options.isHeader,
        original: options.original,
        mode: options.mode,
        selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
        exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
      }
      this.loading = true
      return cecUnmSetsService.exportExcel(params).then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
        this.$utils.downloadExcel(data, options.filename)
        this.loading = false
      }).catch(function (err) {
        if (err.response) {
          console.log(err.response)
        }
      })
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.refreshList()
    }
  }
}
</script>
<style scoped>
.tableTitle{
  padding: 20px 0 10px 0;
  font-weight: bold;
}
.textOverflow{
  overflow: hidden;
  text-overflow: ellipsis;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

